/**
 * Map user-facing / trip destination country names to ISO 3166-1 alpha-2.
 * Used for travel map choropleth join with GeoJSON (via alpha-3).
 */

const ALIASES: Record<string, string> = {
  usa: 'US',
  us: 'US',
  'united states': 'US',
  'united states of america': 'US',
  america: 'US',
  uk: 'GB',
  'united kingdom': 'GB',
  britain: 'GB',
  greatbritain: 'GB',
  england: 'GB',
  scotland: 'GB',
  wales: 'GB',
  uae: 'AE',
  'united arab emirates': 'AE',
  'south korea': 'KR',
  korea: 'KR',
  'czech republic': 'CZ',
  'côte d\'ivoire': 'CI',
  ivorycoast: 'CI',
  vietnam: 'VN',
  russia: 'RU',
  turkey: 'TR',
  türkiye: 'TR',
};

const CANONICAL: Record<string, string> = {
  Afghanistan: 'AF',
  Albania: 'AL',
  Algeria: 'DZ',
  Argentina: 'AR',
  Australia: 'AU',
  Austria: 'AT',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belgium: 'BE',
  Belize: 'BZ',
  Bolivia: 'BO',
  Brazil: 'BR',
  Canada: 'CA',
  Chile: 'CL',
  China: 'CN',
  Colombia: 'CO',
  'Costa Rica': 'CR',
  Croatia: 'HR',
  Cuba: 'CU',
  Denmark: 'DK',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  Ethiopia: 'ET',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  Germany: 'DE',
  Ghana: 'GH',
  Greece: 'GR',
  Guatemala: 'GT',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Ireland: 'IE',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jordan: 'JO',
  Kenya: 'KE',
  Lebanon: 'LB',
  Malaysia: 'MY',
  Mexico: 'MX',
  Morocco: 'MA',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Nigeria: 'NG',
  Norway: 'NO',
  Pakistan: 'PK',
  Panama: 'PA',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Poland: 'PL',
  Portugal: 'PT',
  Romania: 'RO',
  'Saudi Arabia': 'SA',
  Singapore: 'SG',
  'South Africa': 'ZA',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sweden: 'SE',
  Switzerland: 'CH',
  Taiwan: 'TW',
  Tanzania: 'TZ',
  Thailand: 'TH',
  Tunisia: 'TN',
  Turkey: 'TR',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  Uruguay: 'UY',
  Venezuela: 'VE',
  Vietnam: 'VN',
};

/**
 * Returns ISO 3166-1 alpha-2 or undefined if unknown.
 */
export function countryDisplayNameToIso2(country: string): string | undefined {
  const raw = country?.trim();
  if (!raw) return undefined;

  const direct = CANONICAL[raw];
  if (direct) return direct;

  const compact = raw.toLowerCase().replace(/[\s.'’-]/g, '');
  const alias = ALIASES[compact];
  if (alias) return alias;

  const lower = raw.toLowerCase();
  for (const [name, code] of Object.entries(CANONICAL)) {
    if (name.toLowerCase() === lower) return code;
  }

  return undefined;
}
